<template lang="pug">
.form-center
  details.form-center__item(v-for="form in forms" :key="form.id" :open="openId === form.id")
    summary.form-center__title(@click.prevent="toggle(form.id)")
      span {{ form.title }}
      span.form-center__arrow(aria-hidden="true")
    .form-center__body
      .form-center__remarks(v-if="form.remarks" v-html="form.remarks")
      a.form-center__download(v-if="form.download_url" :href="form.download_url" target="_blank" rel="noopener noreferrer" :aria-label="'下載 PDF：' + form.title") 下載 PDF
      p.form-center__unavailable(v-else) 此項目目前未提供下載檔案
  p(v-if="!forms.length") 目前沒有表單
</template>
<script>
export default {
  name: 'FormAccordion',
  props: { forms: { type: Array, default: () => [] } },
  data () { return { openId: null } },
  methods: {
    toggle (id) { this.openId = this.openId === id ? null : id }
  }
}
</script>
<style scoped>
.form-center{padding-top:24px}.form-center__item{border:1px solid #c9d9ce;border-radius:6px;margin-bottom:12px;background:#fff;overflow:hidden}.form-center__title{display:flex;align-items:center;justify-content:space-between;gap:16px;list-style:none;cursor:pointer;padding:18px 20px;color:#235b36;font-size:18px;font-weight:600;line-height:1.5}.form-center__title::-webkit-details-marker{display:none}.form-center__title:focus-visible{outline:2px solid #008e38;outline-offset:-3px}.form-center__arrow{width:9px;height:9px;border-right:2px solid;border-bottom:2px solid;transform:rotate(45deg);flex-shrink:0;margin-right:4px}.form-center__item[open] .form-center__arrow{transform:rotate(225deg)}.form-center__item[open] .form-center__title{background:#f3f8f4}.form-center__body{padding:18px 20px;border-top:1px solid #dfebe2}.form-center__remarks{line-height:1.8;overflow-wrap:anywhere;margin-bottom:18px}.form-center__download{display:inline-block;padding:9px 20px;background:#008e38;color:white;border-radius:4px;text-decoration:none}.form-center__download:hover{background:#006c2b}.form-center__unavailable{color:#666;margin:0;font-size:14px}@media(max-width:575px){.form-center__title{font-size:16px;padding:16px}.form-center__body{padding:16px}}
</style>
